<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="18">
        <el-row :gutter="15">
          <el-col :span="6">
            <el-card
              class="card"
              :style="{ backgroundImage: `url(${imgUrl})` }"
              style="
                height: 160px;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 25px;
              "
            >
              <el-col>
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">人员信息</el-col>
                  </div>
                </el-row>
                <el-row>
                  <div class="context-div">
                    <el-col :span="8">
                      <div @click="add_user_tab()">
                        <el-row class="context-value">
                          {{ info.userCount }}
                        </el-row>
                        <el-row class="context-key"> 现场人员 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="8" style="margin-left: 60px">
                      <div @click="add_duty_tab()">
                        <el-row class="context-value">
                          {{ info.dutyPpersonnelCount }}
                        </el-row>
                        <el-row class="context-key"> 在班人员 </el-row>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card
              class="card"
              :style="{ backgroundImage: `url(${imgUrl})` }"
              style="
                height: 160px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 25px;
              "
            >
              <el-col>
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">设备信息</el-col>
                  </div>
                </el-row>
                <el-row>
                  <div class="context-div">
                    <el-col :span="8">
                      <div @click="add_asset_tab()">
                        <el-row class="context-value">
                          {{ info.assetCount }}
                        </el-row>
                        <el-row class="context-key"> 设备总计 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="8" style="margin-left: 60px">
                      <div @click="add_asset_tab()">
                        <el-row class="context-value">
                          {{ info.focusAssetCount }}
                        </el-row>
                        <el-row class="context-key"> 重点设备 </el-row>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card
              class="card"
              :style="{ backgroundImage: `url(${imgUrl})` }"
              style="
                height: 160px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 25px;
              "
            >
              <el-col :span="14">
                <el-row>
                  <div>
                    <el-col :span="14" class="tatistic-title">巡检信息</el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_ins_tab()">
                    <el-col :span="16" class="tatistic-key">现存计划：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div style="margin-left: 0px">
                        {{ info.insCount == null ? 0 : info.insCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_ins_tab()">
                    <el-col :span="16" class="tatistic-key">今日计划：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todayHappenInsCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_ins_tab()">
                    <el-col :span="16" class="tatistic-key">今日解决：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todaySolveInsCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
              <el-col :span="10" class="circle-container">
                <progress-circle
                  class="circle"
                  :percentage2="info.InsFinishRatio"
                ></progress-circle>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card
              class="card"
              :style="{ backgroundImage: `url(${imgUrl})` }"
              style="
                height: 160px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 25px;
              "
            >
              <el-col :span="14">
                <el-row>
                  <div>
                    <el-col :span="14" class="tatistic-title">保养信息</el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_maintain_tab()">
                    <el-col :span="16" class="tatistic-key">现存计划：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{
                          info.maintainCount == null ? 0 : info.maintainCount
                        }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_maintain_tab()">
                    <el-col :span="16" class="tatistic-key">今日计划：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todayHappenMaintainCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_maintain_tab()">
                    <el-col :span="16" class="tatistic-key">今日解决：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todaySolveMaintainCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
              <el-col :span="10" class="circle-container">
                <progress-circle
                  class="circle"
                  :percentage2="info.maintainFinishRatio"
                ></progress-circle>
              </el-col>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="margin-top: 15px">
          <el-col :span="6">
            <el-card
              class="card"
              :style="{ backgroundImage: `url(${imgUrl})` }"
              style="
                height: 160px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 25px;
              "
            >
              <el-col :span="14">
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">故障信息</el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_fau_tab()">
                    <el-col :span="16" class="tatistic-key">现存故障：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.faultCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_fau_tab()">
                    <el-col :span="16" class="tatistic-key">今日发生：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todayHappenFaultCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_fau_tab()">
                    <el-col :span="16" class="tatistic-key">今日解决：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todaySolveFaultCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
              <el-col :span="10" class="circle-container">
                <progress-circle
                  class="circle"
                  :percentage2="info.faultFinishRatio"
                ></progress-circle>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card
              class="card"
              :style="{ backgroundImage: `url(${imgUrl})` }"
              style="
                height: 160px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 25px;
              "
            >
              <el-col :span="14">
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">任务信息</el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_task_tab()">
                    <el-col :span="16" class="tatistic-key">现存任务：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.taskCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_task_tab()">
                    <el-col :span="16" class="tatistic-key">今日发生：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todayHappenTaskCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_task_tab()">
                    <el-col :span="16" class="tatistic-key">今日解决：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todaySolveTaskCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
              <el-col :span="10" class="circle-container">
                <progress-circle
                  class="circle"
                  :percentage2="info.taskFinishRatio"
                ></progress-circle>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card
              class="card"
              :style="{ backgroundImage: `url(${imgUrl})` }"
              style="
                height: 160px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 25px;
              "
            >
              <el-col :span="14">
                <el-row>
                  <div>
                    <el-col :span="14" class="tatistic-title">维修信息</el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_repair_tab()">
                    <el-col :span="16" class="tatistic-key">现存维修：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.repairCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_repair_tab()">
                    <el-col :span="16" class="tatistic-key">今日发生：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todayHappenRepairCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_repair_tab()">
                    <el-col :span="16" class="tatistic-key">今日解决：</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div>
                        {{ info.todaySolveRepairCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
              <el-col :span="10" class="circle-container">
                <progress-circle
                  :percentage2="info.repairFinishRatio"
                  class="circle"
                ></progress-circle>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card
              class="card"
              :style="{ backgroundImage: `url(${imgUrl})` }"
              style="
                height: 160px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 25px;
              "
            >
              <el-col>
                <el-row>
                  <div>
                    <el-col class="tatistic-title">材料信息</el-col>
                  </div>
                </el-row>
                <el-row>
                  <div class="context-div">
                    <el-col :span="12">
                      <div @click="add_mat_tab()">
                        <el-row class="context-value">
                          {{ info.matConsumes }}
                        </el-row>
                        <el-row class="context-key" style="text-align：center">
                          故障材料使用
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div @click="add_mat_tab()">
                        <el-row class="context-value">
                          {{ info.repairMatConsumes }}
                        </el-row>
                        <el-row class="context-key" style="text-align：center">
                          维修材料使用
                        </el-row>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6">
        <el-card class="main" style="height: 336px; border-radius: 25px">
          <!-- <div id="eleDayFaultHis" @click="add_fau_tab()" style="height: 240px;margin-top: -20px;width: 100%;">
          </div> -->
          <div slot="header" style="color: #0e76ed; font-weight: bold">
            <el-divider class="title-divider" direction="vertical"></el-divider>
            通知
          </div>
          <div class="notice" @click="add_notice_tab()">
            <div
              v-for="(item, index) in notices"
              :key="index"
              class="notice-item"
            >
              <div class="title">{{ index + 1 }}. {{ item.title }}</div>
              <div class="time">{{ item.create_time }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col style="margin-top: 15px" class="main">
        <div class="option">
          <el-select v-model="value" style="width: 100px; height: 5px">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="故障" name="fault" class="el-tab">
            <template #label>
              <div>
                <el-divider
                  class="tab-divider"
                  direction="vertical"
                ></el-divider>
                <span style="font-size: 17px">故障</span>
                <el-divider
                  class="tab-divider"
                  direction="vertical"
                ></el-divider>
              </div>
            </template>

            <div>
              <!-- height: calc(100vh - 780px); -->
              <el-card style="height: calc(100vh - 520px)">
                <!-- height="calc(100vh - 805px)" -->
                <el-table
                  :data="filteredData"
                  ref="fauTable"
                  show-overflow-tooltip
                  border
                  stripe
                  size="mini"
                  v-loading="loading"
                  height="calc(100vh - 545px)"
                  style="overflow: auto"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column prop="code" label="故障单号">
                  </el-table-column>
                  <el-table-column prop="org_name" label="组织名称">
                  </el-table-column>
                  <el-table-column prop="area_name" label="区域名称">
                  </el-table-column>
                  <el-table-column
                    prop="equi_name"
                    label="设备名称"
                    width="200px"
                  >
                  </el-table-column>
                  <el-table-column prop="level_name" label="故障等级">
                    <template slot-scope="scope">
                      <span :class="{'red': scope.row.levelState==1}"
                        >{{ scope.row.level_name }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="appeName"
                    :show-overflow-tooltip="true"
                    label="故障现象"
                  >
                    <template slot-scope="scope">
                      <span>{{
                        scope.row.appe_id == 999999
                          ? scope.row.des == null
                            ? ""
                            : scope.row.des
                          : scope.row.appe_name
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="duration" label="规定完成时长">
                    <template slot-scope="scope">
                      <span style="color: orange"
                        >{{ scope.row.duration }}小时</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="plan_solve_time" label="规定完成时间">
                    <template slot-scope="scope">
                      <span style="color: orange">{{
                        scope.row.plan_solve_time
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="occu_time" label="故障上报时间">
                  </el-table-column>
                  <el-table-column
                    prop="state"
                    label="状态"
                    width="165"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag size="mini" :type="stateFormat(scope.row, 1)">{{
                        scope.row.statename
                      }}</el-tag>
                      <el-tag
                        size="mini"
                        type="danger"
                        style="margin-left: 4px"
                        v-if="
                          scope.row.process != null &&
                          scope.row.process.startsWith('挂起')
                        "
                        >挂起</el-tag
                      >
                      <el-tag
                  size="mini"
                  type="danger"
                  v-if="changeOutTime(scope.row) > scope.row.response_time"
                  >已超时</el-tag
                >
                    </template>
                  </el-table-column>
                   <el-table-column label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        title="详情"
                        @click="add_fau_tab(scope.row)"
                        type="primary"
                        ><i class="el-icon-font el-icon-view"></i
                      ></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="巡检" name="ins">
            <template #label>
              <div class="tab-title">
                <span style="font-size: 17px">巡检</span>
                <el-divider
                  class="tab-divider"
                  direction="vertical"
                ></el-divider>
              </div>
            </template>
            <div>
              <!-- height: calc(100vh - 780px); -->
              <el-card style="overflow-y: auto; height: calc(100vh - 520px)">
                <!-- height="calc(100vh - 805px)" -->

                <el-table
                  :data="filteredData"
                  ref="insTable"
                  show-overflow-tooltip
                  border
                  stripe
                  size="mini"
                  v-loading="loading"
                  height="calc(100vh - 545px)"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column prop="orgName" label="车站名称" width="100">
                  </el-table-column>
                  <el-table-column prop="lineName" label="巡检线路名称">
                  </el-table-column>
                  <el-table-column
                    prop="starttime"
                    label="开始时间"
                    width="140"
                  >
                  </el-table-column>
                  <el-table-column prop="endtime" label="结束时间" width="140">
                  </el-table-column>
                  <el-table-column
                    prop="inspeopleName"
                    label="巡检人员"
                    width="80"
                  >
                  </el-table-column>
                  <el-table-column prop="companionName" label="协作人">
                  </el-table-column>
                  <el-table-column
                    prop="inscount"
                    label="完成/总数"
                    align="center"
                    width="80"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.finishCount == null"
                        >0/{{ scope.row.totalCount }}</span
                      >
                      <span v-else>
                        {{ scope.row.finishCount }}/{{ scope.row.totalCount }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="finishTime"
                    label="最后执行时间"
                    width="140"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="states"
                    label="是否分配"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        v-if="
                          scope.row.inspeopleId != null &&
                          scope.row.inspeopleId != ''
                        "
                        size="mini"
                        type="success"
                        >已分配</el-tag
                      >
                      <el-tag v-else size="mini" type="warning">未分配</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="states" label="状态" align="center">
                    <template slot-scope="scope">
                      <el-tag size="mini" :type="showState(scope.row)">{{
                        scope.row.statename
                      }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="faultcode"
                    label="故障状态"
                    width="80"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        v-if="
                          scope.row.faultCode == null ||
                          scope.row.faultCode == ''
                        "
                        slot="reference"
                        size="mini"
                        type="success"
                        >正常</el-tag
                      >

                      <el-popover v-else placement="top">
                        <p>&nbsp;&nbsp;故障编码</p>
                        <div style="text-align: center; margin: 10">
                          <el-link
                            v-for="(item, index) in scope.row.faultCodelist"
                            :key="index"
                            @click="viewFaultInfo(item)"
                            icon="el-icon-warning"
                            type="danger"
                            >{{ item }}&nbsp;</el-link
                          >
                          <br />
                          <br />
                        </div>
                        <el-tag slot="reference" size="mini" type="danger"
                          >故障</el-tag
                        >
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        title="详情"
                        @click="add_ins_tab(scope.row)"
                        type="primary"
                        ><i class="el-icon-font el-icon-view"></i
                      ></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="保养" name="maintain">
            <template #label>
              <div class="tab-title">
                <span style="font-size: 17px">保养</span>
                <el-divider
                  class="tab-divider"
                  direction="vertical"
                ></el-divider>
              </div>
            </template>
            <div>
              <!-- height: calc(100vh - 780px); -->
              <el-card style="overflow-y: auto; height: calc(100vh - 520px)">
                <!-- height="calc(100vh - 805px)" -->

                <el-table
                  :data="filteredData"
                  ref="maintainTable"
                  show-overflow-tooltip
                  border
                  stripe
                  size="mini"
                  v-loading="loading"
                  height="calc(100vh - 545px)"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column prop="name" label="保养任务名称">
                  </el-table-column>
                  <el-table-column prop="orgName" label="组织">
                  </el-table-column>
                  <el-table-column prop="systemName" label="系统专业">
                  </el-table-column>
                  <el-table-column
                    prop="assetTypeName"
                    label="设备类型"
                    width="90"
                  >
                  </el-table-column>
                  <el-table-column prop="planStartTime" label="计划开始时间">
                  </el-table-column>
                  <el-table-column prop="planEndTime" label="计划结束时间">
                  </el-table-column>
                  <el-table-column
                    prop="finishCount"
                    label="完成数量"
                    width="70"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.finishCount }}/{{ scope.row.totalCount }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="state"
                    label="状态"
                    width="70"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        size="mini"
                        :type="maintainStateFormat(scope.row, 1)"
                        >{{ scope.row.statename }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        title="详情"
                        @click="add_maintain_tab(scope.row)"
                        type="primary"
                        ><i class="el-icon-font el-icon-view"></i
                      ></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="任务" name="task">
            <template #label>
              <div class="tab-title">
                <span style="font-size: 17px">任务</span>
                <el-divider
                  class="tab-divider"
                  direction="vertical"
                ></el-divider>
              </div>
            </template>
            <div>
              <!-- height: calc(100vh - 780px); -->
              <el-card style="overflow-y: auto; height: calc(100vh - 520px)">
                <!-- height="calc(100vh - 805px)" -->

                <el-table
                  :data="filteredData"
                  ref="maintainTable"
                  show-overflow-tooltip
                  border
                  stripe
                  size="mini"
                  v-loading="loading"
                  height="calc(100vh - 545px)"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column prop="name" label="任务名称">
                  </el-table-column>
                  <el-table-column prop="orgName" label="组织">
                  </el-table-column>
                  <el-table-column prop="systemName" label="系统专业">
                  </el-table-column>
                  <el-table-column prop="chargePersonName" label="责任人">
                  </el-table-column>
                  <el-table-column prop="planStartTime" label="计划开始时间">
                  </el-table-column>
                  <el-table-column prop="planEndTime" label="计划结束时间">
                  </el-table-column>

                  <el-table-column
                    prop="state"
                    label="状态"
                    width="82"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        size="mini"
                        :type="taskStateFormat(scope.row, 1)"
                        >{{ scope.row.statename }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        title="详情"
                        @click="add_task_tab(scope.row)"
                        type="primary"
                        ><i class="el-icon-font el-icon-view"></i
                      ></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="维修" name="repair">
            <template #label>
              <div class="tab-title">
                <span style="font-size: 17px">维修</span>
                <el-divider
                  class="tab-divider"
                  direction="vertical"
                ></el-divider>
              </div>
            </template>
            <div>
              <!-- height: calc(100vh - 780px); -->
              <el-card style="overflow-y: auto; height: calc(100vh - 520px)">
                <!-- height="calc(100vh - 805px)" -->
                <el-table
                  :data="filteredData"
                  ref="maintainTable"
                  show-overflow-tooltip
                  border
                  stripe
                  size="mini"
                  v-loading="loading"
                  height="calc(100vh - 545px)"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column prop="code" label="维修单号">
                  </el-table-column>
                  <el-table-column prop="matTypeName" label="材料名称">
                  </el-table-column>
                  <el-table-column prop="matModelName" label="材料类型">
                  </el-table-column>
                  <el-table-column prop="warehouseName" label="仓库名称">
                  </el-table-column>
                  <el-table-column prop="appe" label="故障现象">
                  </el-table-column>
                  <el-table-column prop="price" label="价格"> </el-table-column>
                  <el-table-column prop="unit" label="单位"> </el-table-column>
                  <el-table-column prop="createTime" label="上报时间">
                    <template slot-scope="scope">
                      <span v-if="scope.row.createTime">{{
                        scope.row.createTime.substring(0, 10)
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="state"
                    label="状态"
                    width="110"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        size="mini"
                        :type="repairStateFormat(scope.row, 1)"
                        >{{ scope.row.statename }}</el-tag
                      >
                      <el-tag
                        size="mini"
                        type="danger"
                        style="margin-left: 4px"
                        v-if="
                          scope.row.process != null &&
                          scope.row.process.startsWith('挂起')
                        "
                        >挂起</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        title="详情"
                        @click="add_repair_tab(scope.row)"
                        type="primary"
                        ><i class="el-icon-font el-icon-view"></i
                      ></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dateutils from "../utils/dateutils.js";

import "ol/ol.css";
import ProgressCircle from "./ProgressCircle.vue";
// import { Style, Circle, Fill } from "ol/style"

export default {
  name: "eshome",
  components: {
    ProgressCircle,
  },
  data() {
    return {
      options: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "未完成",
        },
        {
          value: "2",
          label: "已完成",
        },
      ],
      value: "0",
      loading: false,
      queryObj: { starttime: [], endtime: [] }, //查询条件
      dayFaultHis: [],
      faultlist: [], //故障列表
      inslist: [], //巡检数据
      maintain: [], //保养数据
      tasklist: [], //任务数据
      repairlist: [], //维修数据
      info: {}, //总览数据
      wrnameData: [],
      wrnameDataMess: {},
      map: null,
      layer: null,
      pointLayer: null,
      wrnameDataMessView: false,
      imgUrl: require("../assets/imgs/eshome.png"),
      notices: [], //通告列表
      //标题页默认选择 故障
      activeName: "fault",
      filteredData: [], // 筛选后的数据
    };
  },
  methods: {
    init() {
      this.getOutlinedata();
      this.getNoticeData();
      //this.loadDayFaultHis();
    },
    getOutlinedata() {
      this.$ajax
        .get("/buss/home/get_outlinedata")
        .then((msg) => {
          this.info = msg;
          this.faultlist = msg.faultList;
          this.inslist = msg.insList;
          this.maintain = msg.maintainList;
          this.tasklist = msg.taskList;
          this.repairlist = msg.repairList;
          this.filterData();
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    getNoticeData() {
      this.$ajax
        .get("/buss/home/getNoticeData")
        .then((msg) => {
          this.notices = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    stateFormat(row, type) {
      if (row.state == 1) {
        if (type == 1) {
          row.statename = "待分配";
          return "warning";
        }
        return "待分配";
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "待解决";
          return "primary";
        }
        return "待解决";
      } else {
        if (type == 1) {
          row.statename = "已解决";
          return "success";
        }
        return "已解决";
      }
    },
    //显示状态，type=1列表用，type=2详情用
    maintainStateFormat(row, type) {
      if (row.state == 0) {
        if (type == 1) {
          row.statename = "未执行";
          return "primary";
        }
        return "未执行";
      } else if (row.state == 1) {
        if (type == 1) {
          row.statename = "部分完成";
          return "primary";
        }
        return "部分完成";
      } else {
        if (type == 1) {
          row.statename = "已完成";
          return "success";
        }
        return "已完成";
      }
    },
    taskStateFormat(row, type) {
      var nowTime = dateutils.dateFormat("YYYY-mm-dd HH:MM:SS", new Date()); //当前时间

      if (row.state == 0 && nowTime < row.planStartTime) {
        if (type == 1) {
          row.statename = "未开启";
          return "primary";
        }
        return "未开启";
      } else if (
        row.state == 0 &&
        nowTime >= row.planStartTime &&
        nowTime <= row.planEndTime
      ) {
        if (type == 1) {
          row.statename = "执行中";
          return "primary";
        }
        return "执行中";
      } else if (
        row.state == 1 &&
        row.doneTime >= row.planStartTime &&
        row.doneTime <= row.planEndTime
      ) {
        if (type == 1) {
          row.statename = "已完成";
          return "success";
        }
        return "已完成";
      } else if (row.state == 1 && row.doneTime > row.planEndTime) {
        if (type == 1) {
          row.statename = "逾期完成";
          return "warning";
        }
        return "逾期完成";
      } else {
        if (type == 1) {
          row.statename = "未完成";
          return "danger";
        }
        return "未完成";
      }
    },
    //显示状态，type=1列表用，type=2详情用
    repairStateFormat(row, type) {
      if (row.state == 1) {
        if (type == 1) {
          row.statename = "待分配";
          return "warning";
        }
        return "待分配";
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "待解决";
          return "primary";
        }
        return "待解决";
      } else if (row.state == 3) {
        if (type == 1) {
          row.statename = "已解决";
          return "success";
        }
        return "已解决";
      } else if (row.state == 4) {
        if (type == 1) {
          row.statename = "高价值作废";
          return "danger";
        }
        return "高价值作废";
      } else if (row.state == 5) {
        if (type == 1) {
          row.statename = "作废";
          return "danger";
        }
        return "作废";
      }
    },
    showState(row) {
      if (row.state == 2) {
        if (new Date(row.finishTime) > new Date(row.endtime)) {
          row.statename = "逾期完成";
          return "warning";
        } else {
          row.statename = "完成";
          return "success";
        }
      } else {
        if (new Date() > new Date(row.endtime)) {
          row.statename = "计划过期";
          return "danger";
        } else {
          row.statename = "未完成";
          return "primary";
        }
      }
    },
    loadDayFaultHis() {
      this.queryObj.starttime = dateutils.dateFormat(
        "YYYY-mm-01 00:00:00",
        new Date()
      );
      this.queryObj.endtime = dateutils.dateFormat(
        "YYYY-mm-dd 23:59:59",
        new Date()
      );
      this.$ajax
        .get("/buss/statisticfault/dayfaulthis", this.queryObj)
        .then((msg) => {
          this.dayFaultHis = msg;
          this.initLineDayFaultHis(this.dayFaultHis, "eleDayFaultHis", "");
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    add_fau_tab(row) {
      if (this.$store.getUser().menus.indexOf("/fault/faultquery") >= 0) {
        let param = {
          id: 48,
          label: "故障查询",
          icon: "el-icon-yulanchakan",
          url: "/fault/faultquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有故障查询权限");
      }
    },
    add_ins_tab(row) {
      if (this.$store.getUser().menus.indexOf("/ins/insquery") >= 0) {
        let param = {
          label: "巡检查看",
          url: "/ins/insquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有巡检查看查看权限");
      }
    },
    add_task_tab(row) {
      if (this.$store.getUser().menus.indexOf("/task/taskquery") >= 0) {
        let param = {
         id: 72,
          label: "任务查看",
          icon: "el-icon-chaxun",
          url: "/task/taskquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有任务查看权限");
      }
    },
    add_maintain_tab(row) {
      if (this.$store.getUser().menus.indexOf("/maintain/maintainquery") >= 0) {
        let param = {
        id: 92,
          label: "保养查看",
          icon: "el-icon-paibanchaxun",
          url: "/maintain/maintainquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有保养查看权限");
      }
    },
    add_mat_tab() {
      if (this.$store.getUser().menus.indexOf("/mat/matconsumequery") >= 0) {
        this.$emit("add-tab", {
          id: 38,
          label: "物料使用",
          icon: "el-icon-chakan",
          url: "/mat/matconsumequery",
        });
      } else {
        this.$message.error("你没有物料使用查看权限");
      }
    },
    add_user_tab() {
      if (this.$store.getUser().menus.indexOf("/system/account") >= 0) {
        this.$emit("add-tab", {
          id: 12,
          label: "账户管理",
          icon: "el-icon-yonghu",
          url: "/system/account",
        });
      } else {
        this.$message.error("你没有账户管理权限");
      }
    },
    add_repair_tab(row) {
      if (this.$store.getUser().menus.indexOf("/repair/repairquery") >= 0) {
         let param = {
        id: 12,
          label: "维修查看",
          icon: "el-icon-yulanchakan",
          url: "/repair/repairquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有维修查看权限");
      }
    },
    add_duty_tab() {
      if (
        this.$store.getUser().menus.indexOf("/rostering/rosteringnowduty") >= 0
      ) {
        this.$emit("add-tab", {
          id: 84,
          label: "在班人员",
          icon: "el-icon-jihua",
          url: "/rostering/rosteringnowduty",
        });
      } else {
        this.$message.error("你没有在班人员权限");
      }
    },
    add_notice_tab() {
      if (this.$store.getUser().menus.indexOf("/system/notice") >= 0) {
        this.$emit("add-tab", {
          id: 17,
          label: "通知公告",
          icon: "el-icon-gonggao",
          url: "/system/notice",
        });
      } else {
        this.$message.error("你没有在通知公告权限");
      }
    },
    add_asset_tab() {
      if (this.$store.getUser().menus.indexOf("/asset/asset") >= 0) {
        this.$emit("add-tab", {
          id: 21,
          label: "设备管理",
          icon: "el-icon-shebeizuguanli",
          url: "/asset/asset",
        });
      } else {
        this.$message.error("你没有设备管理权限");
      }
    },
    showInsDevicePlan(row) {
      console.log(row);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    changeStatus() {
      console.log(this.value);
      console.log(this.activeName);
    },
    filterData() {
      if (!this.value || this.value === "0") {
        // 如果筛选条件为空，显示全部数据
        if (this.activeName === "fault") {
          this.filteredData = this.faultlist;
        } else if (this.activeName === "ins") {
          this.filteredData = this.inslist;
        } else if (this.activeName === "maintain") {
          this.filteredData = this.maintain;
        } else if (this.activeName === "task") {
          this.filteredData = this.tasklist;
        } else if (this.activeName === "repair") {
          this.filteredData = this.repairlist;
        }
      } else {
        // 否则，根据条件筛选数据
        if (this.activeName === "fault") {
          this.filteredData = this.faultlist.filter((item) => {
            if (this.value === "2") {
              return item.state === 3;
            } else {
              return item.state != 3;
            }
          });
        } else if (this.activeName === "ins") {
          this.filteredData = this.inslist.filter((item) => {
            if (this.value === "2") {
              return item.state === 2;
            } else {
              return item.state != 2;
            }
          });
        } else if (this.activeName === "maintain") {
          this.filteredData = this.maintain.filter((item) => {
            if (this.value === "2") {
              return item.state === 2;
            } else {
              return item.state != 2;
            }
          });
        } else if (this.activeName === "task") {
          this.filteredData = this.tasklist.filter((item) => {
            if (this.value === "2") {
              return item.state === 1;
            } else {
              return item.state != 1;
            }
          });
        } else if (this.activeName === "repair") {
          this.filteredData = this.repairlist.filter((item) => {
            if (this.value === "2") {
              return item.state === 3;
            } else {
              return item.state != 3;
            }
          });
        }
      }
    },
    changeOutTime(row) {
      console.log(row.arrive_time);
      console.log(row.occu_time);
      console.log(new Date(row.arrive_time));
      console.log(new Date(row.occu_time));
      let hours = parseInt(
        (new Date(row.arrive_time) - new Date(row.occu_time)) / (1000 * 60 * 60)
      );
      console.log(row.code + "---------------" + hours);
      //计算天数后剩余的毫秒数
      let leave1 =
        (new Date(row.arrive_time).getTime() -
          new Date(row.occu_time).getTime()) %
        (24 * 3600 * 1000);
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      let a = minutes == "0" ? hours : hours + 1;
      console.log(a);
      console.log(row.duration)
      console.log(row.response_time)
      
      return a;
    },
  },

  created() {
    this.init();
    setInterval(() => {
      this.init();
    }, 30000); // 30秒刷新一次
  },
  watch: {
    value() {
      // 监听筛选条件的变化，当条件变化时重新筛选数据
      this.filterData();
    },
    activeName() {
      this.filterData();
      this.value = "0";
    },
  },
};
</script>

<style  scoped>
.card-context {
  height: 200px;
}

.title-context {
  height: 160px;
  border-radius: 10px;
  margin-top: 10px;
}

.context-div {
  margin-left: 10px;
  margin-top: 10px;
  text-align: center;
}

.context-value {
  color: rgb(0, 0, 0);
  font-size: 25px;
  margin-top: 25px;
  font-weight: bold;
}

.context-key {
  color: rgb(0, 0, 0);
  font-size: 15px;

  font-weight: bold;
}

.tatistic-div {
  height: 85px;
  background: #c9e0f6;
  border-radius: 5px;
  margin-top: 5px;
  text-align: center;
}

.tatistic-dialog-div {
  height: 85px;
  background: #e5d7f6;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}

.tatistic-value {
  color: rgb(0, 0, 0);
  margin-top: 15px;
  text-align: left;
  font-size: 15px;
  font-weight: bold;
}

.tatistic-key {
  color: rgb(0, 0, 0);
  margin-top: 15px;
  /* text-align: right; */
  text-align: right;
  font-size: 15px;
  font-weight: bold;
}

.context-icon {
  font-size: 40px;
  font-weight: 500;
  margin-top: -20px;
  margin-right: -10px;
}

.card-table {
  height: calc(100vh - 730px);
}

.card-con {
  height: calc(100vh - 350px);
}

.el-aside {
  /* background-color: #8dccf7; */
  color: rgb(255, 255, 255);
  text-align: center;
  line-height: 90px;
}

.el-main {
  /* background-color: #a2d7f9; */
  color: rgb(247, 251, 251);
  text-align: center;
  line-height: 50px;
}

.map {
  height: 390px;
  width: 100%;
  box-shadow: 0 0 0 0 rgb(0 0 0 / 10%);
  background-color: #fff;
  transition: 0.3s;
  overflow: hidden;
}

.tatistic-title {
  color: rgb(255, 255, 255);
  font-size: 17px;
  margin-top: 0px;
}

.notice-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

.title {
  font-size: 13px;
  color: #5c5c5c;
}

.time {
  font-size: 13px;
  color: #5c5c5c;
}

.circle-container {
  height: 150px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
}

.main /deep/ .el-tabs__nav-scroll {
  background-color: #3dc3f6;
}

.main /deep/ .el-tabs__item.is-active {
  color: #000000 !important;
}

.main /deep/ .el-tabs__item {
  color: #fff;
  font-weight: bold;
}

.main /deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0px solid #e4e7ed;
}

.main /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-bottom: 0px solid transparent;
  border-left: 0px solid #e4e7ed;
}

.tab-divider {
  border-top: 0px solid;
  border-bottom: 0px solid;
  padding: 1px;
  pointer-events: none;
  /* 设置不参与点击事件 */
}

.tab-title {
  margin-left: -30px;
}

.title-divider {
  background-color: #0e76ed;
  border-top: 0px solid;
  border-bottom: 0px solid;
  padding: 1px;
  top: -1px;
}

.main /deep/ .el-card__header {
  position: sticky;
  top: 0;
  z-index: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice {
  overflow: auto;
  height: 260px;
}

.option {
  float: right;
  clear: left;
}

.main /deep/ .el-tabs__header.is-top {
  background-color: #3dc3f6;
  overflow: hidden;
}

.main /deep/ .el-input__inner {
  height: 35px;
  background-color: #3dc3f6;
  margin-right: 50px;
  border: 0px solid #ffffff;
  border-radius: 0px;
  color: #ffffff;
  font-weight: bold;
}

.main /deep/ .el-icon-arrow-up:before {
  color: #ffffff;
}

.circle {
  height: 140px;
  width: 200px;
  transform-origin: center;
  transition: transform 0.5s ease-out;
}

.card:hover .circle {
  transform: scale(0.9);
}
.red{
  color:red;
}
</style>
